<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Shipping Fees"></app-breadcrumb>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mb-n2">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>
        
        <!-- page heading -->
        <div class="row">
            <div class="col-12">
                <p>
                    <span class="h3 md-small-text">Shipping Fees</span> <br> 
                    <span class="d-none d-md-block">(select a category to add fees to its sub-categories here)</span>
                </p>
            </div>
        </div>

        <!-- select category -->
        <div class="row">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <form>
                            <label for="categoryName" class="font-weight-bold">Select Category</label>
                            <div class="input-group">
                                <select v-model="selectedCategoryName" class="custom-select no-lines" style="border-color: #DFDFDF;">
                                    <option selected disabled value="">category name</option>
                                    <option v-for="(x, i) in theMainCategories" :key="i" :value="x.category">{{x.category | capitalize}}</option>
                                </select>
                                <div class="input-group-append">
                                    <div class="input-group-text bg-light font-weight-bold">
                                        <i class="fas fa-layer-group"></i>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- import the sub categories -->
        <app-sub-categories-fees :categoryName="selectedCategoryName"></app-sub-categories-fees>
        
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../shared/Breadcrumb.vue'
import SubCategoriesFees from './shippingFeesParts/SubCategoriesFees.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "ShippingFees",
    props: {
        categoryName: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            msg: '',
            color: 'danger',
            selectedCategoryName: ''
        }
    },
    methods: {
        ...mapActions(['fetchMainCategoriesAction']),
        fetchMainCategoriesFxn() {
            if(this.theMainCategories.length) return
            this.fetchMainCategoriesAction().then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['setMainCategories']),
        theMainCategories(){
            if(this.setMainCategories){
                return this.setMainCategories
            }
            return [] 
        },
    },
    components: {
        appSubCategoriesFees: SubCategoriesFees,
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchMainCategoriesFxn()
        this.$emit('update:layout', LayoutShop);
    }
}
</script>